function createReducer(handlers) {
    return function reducer(state, action) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action);
        }
        return state;
    };
}

function iniCesta(state, action) {
    return {
        ...state,
        cesta: {
            lineas: null
        }
    };
}

function setLineas(state, action) {
    return {
        ...state,
        cesta: {
            lineas: action.lineas
        }
    };
}

const motoscatReducer = createReducer({
    INI_CESTA: iniCesta,
    CHANGE_LINEAS_CESTA: setLineas
});

export default motoscatReducer;
